<template>
    <SimpleTable
        :flat="true"
        title="Eventos Asistidos"
        subtitle="Eventos a los que ha asistido"
        :columns="columns"
        :data="eventos"
        empty-text="No hay eventos asistidos"
        :default-col-width="defaultColWidth"
    />
</template>

<script setup>
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue'

    const props = defineProps({
        eventos: {
            type: Array,
            default: () => []
        },
        temporada: {
            type: String,
            default: ''
        },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    })

    const columns = [
        { key: 'nombre', label: 'Evento', class: 'tw:w-46' },
        { key: 'hora_entrada', label: 'Hora' },
        { key: 'fecha', label: 'Fecha' },
        { key: 'asiento', label: 'Asiento' }
    ]
</script>
